import React, { useEffect, useState } from "react";
import Cookie from "cookie-universal";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseURL, USER } from "../../../Api/Api";
import HomeDash from "../Home/HomeDash";

function RequireAuth() {
  const [user, setUser] = useState("");

  const cookie = Cookie();
  const token = cookie.get("dashboardLogin"); // Token from cookie

  useEffect(() => {
    if (token) {
      axios
        .get(`${baseURL}/${USER}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => setUser(response.data))
        .catch((error) => console.error("Error fetching user data:", error));
    }
  }, [token]);

  return token ? (
    user === "" ? (
      "" // Loading state
    ) : user.role === "admin" ? ( // Check 'role' instead of 'roles'
      <HomeDash /> // Admin dashboard
    ) : (
      <Navigate to={"/"} replace={true} /> // Redirect non-admins to home
    )
  ) : (
    <Navigate to={"/login"} replace={true} /> // Redirect to login if no token
  );
}

export default RequireAuth;
